import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { RedditService } from '../../Services/reddit.service';
import { IGetRedditSubmissionsData } from '../../Models/IRedditPost';

@Component({
  selector: 'app-reddit-submission-details',
  templateUrl: './reddit-submission-details.component.html',
  styleUrls: ['./reddit-submission-details.component.scss']
})
export class RedditSubmissionDetailsComponent implements OnInit {
  @Input() submissionId?: number;
  submissionDetails: IGetRedditSubmissionsData | null = null;
  isLoading = false;
  error: string = '';

  //icons
  faExternalLink = faExternalLink;

  constructor(
    private drawerRef: NzDrawerRef<RedditSubmissionDetailsComponent>,
    private redditService: RedditService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.submissionId) {
      this.loadSubmissionDetails();
    } else {
      this.error = 'No submission ID provided';
    }
  }

  loadSubmissionDetails(): void {
    this.isLoading = true;
    this.error = '';
    
    this.redditService.getSubmissionDetails(this.submissionId as number)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response: IGetRedditSubmissionsData) => {
          this.submissionDetails = response;
          
          // Check if submissionDetails has the required properties
          if (!this.submissionDetails || typeof this.submissionDetails !== 'object') {
            this.error = 'Invalid response format received';
          }
        },
        error: (error) => {
          this.error = 'Failed to load submission details. Please try again.';
        }
      });
  }


  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

  close(): void {
    this.drawerRef.close();
  }
}